module.exports = ".banner-wrap{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center!important;\r\n        -ms-flex-align: center!important;\r\n            align-items: center!important;\r\n    margin-bottom: 20px;\r\n}\r\n.banner-pic img{\r\n    max-width: 100%;\r\n    display: block;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/banner/banner.component.css
// module id = ./src/app/core/banner/banner.component.css
// module chunks = dashboard.module